import api from 'api';

export const loadStatuses = api('GET /api/applications/filters/statuses');
